/**
 * 게시 중단 요청 — 푸터 버튼을 누르면 창을 열고, 보내면 접수한다 (inc/takedown.php).
 *
 * 창과 폼은 서버가 함께 내려보내므로 여기서는 여닫기·범위 토글·요청만 맡는다.
 * <dialog> 라서 초점 가두기와 Esc 닫기는 브라우저가 한다 — 회원 탈퇴 창과 같은 방식.
 *
 * 실패하면 창을 닫지 않고 그 안에 이유를 적는다. 창이 닫혀 버리면 무엇이
 * 잘못됐는지 모른 채 다시 누르게 되고, 옵트아웃은 그렇게 놓치면 안 되는 요청이다.
 */
const InitAcademyTakedown = () => {
  const dialog = document.querySelector('[data-academy-takedown-dialog]');
  const trigger = document.querySelector('[data-academy-takedown]');
  const config = window.qrshopAcademy;

  if (!dialog || !trigger || typeof dialog.showModal !== 'function') {
    return;
  }

  const form = dialog.querySelector('[data-academy-takedown-form]');
  const error = dialog.querySelector('[data-academy-takedown-error]');
  const done = dialog.querySelector('[data-academy-takedown-done]');
  const cancel = dialog.querySelector('[data-academy-takedown-cancel]');
  const submit = dialog.querySelector('[data-academy-takedown-submit]');
  const targetField = dialog.querySelector('[data-academy-takedown-target]');

  const say = (node, message) => {
    if (!node) {
      return;
    }

    node.textContent = message || '';
    node.hidden = !message;
  };

  trigger.addEventListener('click', () => {
    say(error, '');
    say(done, '');
    dialog.showModal();
  });

  cancel?.addEventListener('click', () => dialog.close());

  // 바깥(백드롭)을 눌러도 닫는다 — 안쪽 상자를 누른 경우는 제외한다.
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      dialog.close();
    }
  });

  // '특정 글만'을 골랐을 때만 주소 칸을 보인다.
  form?.addEventListener('change', (event) => {
    if (event.target.name !== 'scope' || !targetField) {
      return;
    }

    targetField.hidden = event.target.value !== 'post';
  });

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (!config?.restUrl || !config?.nonce) {
      say(error, '잠시 뒤 다시 시도해 주세요.');
      return;
    }

    const data = Object.fromEntries(new FormData(form).entries());

    submit.disabled = true;
    say(error, '');

    try {
      const response = await fetch(`${config.restUrl}/takedown`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': config.nonce },
        body: JSON.stringify(data),
      });
      const body = await response.json();

      if (!response.ok || !body?.success) {
        throw new Error(body?.message || '접수에 실패했습니다.');
      }

      // 보낸 뒤에는 폼을 지우고 결과만 남긴다 — 같은 요청을 두 번 보내지 않게.
      form.reset();
      if (targetField) {
        targetField.hidden = true;
      }
      say(done, body.message);
    } catch (requestError) {
      say(error, requestError.message);
    }

    submit.disabled = false;
  });
};

export default InitAcademyTakedown;
